/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NonceAttestationData } from './NonceAttestationData';
import {
    NonceAttestationDataFromJSON,
    NonceAttestationDataFromJSONTyped,
    NonceAttestationDataToJSON,
} from './NonceAttestationData';

/**
 * 
 * @export
 * @interface NonceAttestationAllOf
 */
export interface NonceAttestationAllOf {
    /**
     * 
     * @type {NonceAttestationData}
     * @memberof NonceAttestationAllOf
     */
    data?: NonceAttestationData;
}

/**
 * Check if a given object implements the NonceAttestationAllOf interface.
 */
export function instanceOfNonceAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonceAttestationAllOfFromJSON(json: any): NonceAttestationAllOf {
    return NonceAttestationAllOfFromJSONTyped(json, false);
}

export function NonceAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : NonceAttestationDataFromJSON(json['data']),
    };
}

export function NonceAttestationAllOfToJSON(value?: NonceAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': NonceAttestationDataToJSON(value.data),
    };
}

